import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { NOTIFICATION_BASE_CLASSNAME } from './Constants';
import { createNotification } from './Notification';
createComponents(".".concat(NOTIFICATION_BASE_CLASSNAME), createNotification, NO_PATTERN_BUSINESS_LOGIC);
